<section class="support_center_sec">
  <div class="mb-20 " fxLayout="row" fxLayout.xl="row" fxLayout.lg="row" fxLayout.md="row" fxLayout.sm="row"
    fxLayout.xs="column" fxLayoutAlign="start stretch" fxLayoutGap="15px">
    <div class="column support_center_sec_col" fxFlex.xl="100" fxFlex.lg="31005" fxFlex.md="100" fxFlex.sm="100"
      fxFlex.xs="100" fxFlexFill fxLayoutAlign="end end">
      <button type="button" class="btn btn-sm global-btn" mat-button (click)="raiseSupport()">
        Raise Support Request
      </button>
    </div>
  </div>
  <div class="support_request" fxLayout="row" fxLayout.xl="row" fxLayout.lg="row" fxLayout.md="row" fxLayout.sm="row"
    fxLayout.xs="column" fxLayoutAlign="start stretch" fxLayoutGap="15px">
    <div class="column support_request_column" fxFlex.xl="35" fxFlex.lg="35" fxFlex.md="35" fxFlex.sm="35"
      fxFlex.xs="100" fxFlexFill>
      <div class="support_center_listing">
        <div class="support_center_listing_tophead supplies_add_form">
          <div class="custom_tabs featured_toggle ">
          <mat-button-toggle-group [formControl]="status" (change)="setStatus()">
            <mat-button-toggle value="OPEN"> Open </mat-button-toggle>
            <mat-button-toggle value="CLOSED"> Closed </mat-button-toggle>
          </mat-button-toggle-group>
        </div>
          <!-- SEARCH -->
          <div class="support_center_listing_head">
          <form (ngSubmit)="setSearch()">
            <div class="custom-form-group custom-form-search">
              <div class="custom-form-control">
                <mat-form-field appearance="outline">
                  <input type="number" matInput placeholder="Enter request number" [formControl]="search">
                  <mat-icon matSuffix (click)="setSearch()">
                    <img src="../../../../../../../assets/images/icons/search_grey.svg" alt="img" class="search-icon">
                  </mat-icon>
                </mat-form-field>
              </div>
            </div>
          </form>
        </div>
        </div>
        <div class="support_center_listing_body">
          <ng-container *ngIf="supportRequestListing;else loadingTemplate">
            <ng-container *ngIf="supportRequestListing.length; else noDataTemplate">
              <ul>
                <li *ngFor="let single of supportRequestListing"
                  [ngClass]="{'active' : single.id === selectedSupportRequest?.id}" (click)="selectRequest(single)">
                  <h4>Request Number : {{single.support_request_number}}</h4>
                  <h4>Request Type :
                    <span *ngIf="single.type ==='GENERAL'"> General </span>
                    <span *ngIf="single.type ==='SUPPLY'"> Orders </span>
                    <span *ngIf="single.type ==='SECOND_HAND_SUPPLY'"> Pre owned orders </span>
                  </h4>
                  <h4>Reason : {{single.reason.substr(0, 100)}} <span *ngIf="single.reason.length > 100">... </span>
                  </h4>
                  <p class="support_description">
                    {{single.message.substr(0,100)}}
                    <span *ngIf="single.message.length > 100">... </span>
                  </p>
                  <div class="flex_support">
                    <p class="time"> {{single.created_at | date: 'dd-MMM-yyyy hh:mm:ss'}}</p>
                  </div>
                </li>
              </ul>
            </ng-container>
          </ng-container>
          <ng-template #loadingTemplate>
            <div class="custom-loader custom_logo_loader">
              <img src='../../../../../images2/loader.gif' alt="img" loading="lazy" />
            </div>
          </ng-template>
          <ng-template #noDataTemplate>
            <div class="no-data empty-img">
              <!-- EMPTY-STATE -->
              <img src='../../../../../../../assets/images/empty-imgs/no_support_req.svg' alt="img" loading="lazy" />
              <h4 class="no_state_heading">No Support Request</h4>
            </div>
          </ng-template>
        </div>
      </div>
    </div>
    <div class="column support_request_column" fxFlex.xl="65" fxFlex.lg="65" fxFlex.md="65" fxFlex.sm="65"
      fxFlex.xs="100" fxFlexFill>
      <div class="support_center_right" *ngIf="selectedSupportRequest">
        <perfect-scrollbar>
          <div class="support_msg_box">
            <div class="head">
              <h4>Request Number :{{selectedSupportRequest?.support_request_number}}</h4>
              <h4>Request Type :
                <span *ngIf="selectedSupportRequest.type ==='GENERAL'"> General </span>
                <span *ngIf="selectedSupportRequest.type ==='SUPPLY'"> Orders </span>
                <span *ngIf="selectedSupportRequest.type ==='SECOND_HAND_SUPPLY'"> Pre owned orders </span>
              </h4>
              <span class="time"> {{selectedSupportRequest?.created_at | date: 'dd-MMM-yyyy hh:mm:ss'}} </span>
            </div>
            <h2 class="reason_title">Reason : {{selectedSupportRequest?.reason}} </h2>
            <h2 class="reason_title" *ngIf="selectedSupportRequest?.supplies_order?.order_number"> Order No :
              {{selectedSupportRequest?.supplies_order?.order_number}} </h2>
            <h2 class="reason_title" *ngIf="selectedSupportRequest?.second_hand_supplies_order?.order_number"> Order No
              : {{selectedSupportRequest?.second_hand_supplies_order?.order_number}} </h2>
            <div class="custom-form-group">
              <label for="">Message : </label>
              <p>
                {{selectedSupportRequest?.message}}
              </p>
            </div>
            <!-- Attachments -->
            <div class="custom-form-group attachment_form_group" *ngIf="
            selectedSupportRequest?.attachments
            && selectedSupportRequest?.attachments.length">
              <label class="custom-label fx-display" for="">Attachments</label>
              <div class="custom-form-control">
                <div class="upload_preview" *ngFor="let single of selectedSupportRequest?.attachments">
                  <a [href]="single.url" target="_blank">
                    <img [src]="single.url" alt="" class="preview_img">
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div class="support_msg_box" *ngIf="selectedSupportRequest?.reply">
            <div class="head">
              <h4>Support Reply</h4>
              <span class="time">{{selectedSupportRequest?.updated_at | date: "dd MMMM, yyyy hh:mma"}}</span>
            </div>
            <div class="custom-form-group">
              <label for="">Message : </label>
              <p>{{selectedSupportRequest?.reply}}</p>
            </div>
            <!-- Attachments -->
            <div class="custom-form-group attachment_form_group"
              *ngIf="selectedSupportRequest?.reply_attachments && selectedSupportRequest?.reply_attachments.length">
              <label class="custom-label fx-display" for="">Reply Attachments</label>
              <div class="custom-form-control">
                <div class="upload_preview" *ngFor="let single of selectedSupportRequest?.reply_attachments">
                  <a [href]="single.url" target="_blank">
                    <img [src]="single.url" alt="" class="preview_img">
                  </a>
                </div>
              </div>
            </div>
          </div>
        </perfect-scrollbar>
      </div>
    </div>
  </div>
</section>
